export const NEW_MEMBER_CPT = {
  intro: "NewMemberGuideIntro",
  setting: "NewMemberGuideSetting",
};

export const ADD_QUESTION = "ADD_QUESTION";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const UPDATE_QUESTION = "UPDATE_QUESTION";

// 问题的的选项
export const QUESTION_TYPES = {
  MULTI: "multi",
  REQUIRED: "required",
};

// 新手教程Wrapper Dialog子组件类型
export const SUB_DIALOG_TYPE = {
  CHANNEL: "channel",
  QUESTION: "question",
  GUIDANCE: "guidance",
};

// 触发GUIDER的类型
export const GUIDER_TYPE = {
  PREVIEW: "preview",
  GUIDE: "guide",
};

// 按钮的操作
export const ANSWER_OP_TYPE = {
  REVOKE: "revoke",
  GRANT: "grant",
};

// 新手教程中点击按钮操作对应的flags变化
export const NEW_FLAG_MAP = {
  [ANSWER_OP_TYPE.REVOKE]: "0",
  [ANSWER_OP_TYPE.GRANT]: "1",
};

export const PRIVATE_OP = "Private";
export const PASSWORD_OP = "Password";
export const Delete_OP = "Delete";

// 频道的新手教程敏感操作 是否影响到可聊频道
export const CHANNEL_OPERATION_NEW_MEMBER_ABOUT_MAP = {
  ViewingChannel: true, // 修改频道是否全体成员可见
  JoinAudioChannel: false, // 修改频道是否全体成员可加入语音频道
  SendIM: false, // 修改频道是否全体成员可发送IM消息
  [PRIVATE_OP]: true, // 修改频道是否为私密频道
  [PASSWORD_OP]: true, // 修改频道是否需要密码
  [Delete_OP]: true, // 删除频道
};

// 最小可用频道数
export const MIN_USEABLE_CHANNEL_COUNT = 7;

// 最小可聊频道数
export const MIN_CHATTABLE_CHANNEL_COUNT = 5;

// 如果敏感操作的新值是这个的话，可以忽略，不再进行运算
export const NEW_VALUE_IGNORE = {
  [PRIVATE_OP]: false, // 修改频道是否为私密频道
  [PASSWORD_OP]: false,
  ViewingChannel: true, // 修改频道是否全体成员可见
  JoinAudioChannel: true, // 修改频道是否全体成员可加入语音频道
  SendIM: true,
};
